import cloneDeep from 'lodash/fp/cloneDeep'
import { listDifferenceComputer } from '../../../../../common/ReducerHelperFunctions/listDifferenceComputer'
import {
  PENDING_APPROVAL_START_EDITING_CONFLICT_DECLARATIONS
  , PENDING_APPROVAL_STOP_EDITING_CONFLICT_DECLARATIONS
  , PENDING_APPROVAL_CANCEL_EDITING_CONFLICT_DECLARATIONS
  , PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_FETCHED_CONFLICT_DECLARATIONS
  , PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_CONFLICT_DECLARATION_SELECTED_CHANGED
  , PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_NO_CONFLICT_SELECTED
} from './pendingApprovalAdviserProfileConflictDeclarationsEditorActions'

import { events as containerEvents } from '../../AdviserProfileApprovalEditorContainer/adviserProfileApprovalEditorContainerActions'

import { validiateChecklistField } from '../../../../../common/forms/validationFunctions'

const initialState = {
  loadingDeclarations: false,
  editingDeclarations: false,
  conflictDeclarationsBeforeEditing: [],
  conflictDeclarationsModifications: [],
  allDeclarations: [],
  isInvalid: {
    formIsValid: true,
    conflictDeclarations: {
      isInvalid: false,
      message: null
    }
  }
}

const minimumRequiredSelection = 0

export default function (state = initialState, action) {
  var newState = copyConflictDeclarationsState(state)

  switch (action.type) {
    case containerEvents.fetch.fetched:
      newState.conflictDeclarations.conflictDeclarationsModifications = findConflictDeclarationsDifferences(newState)
      return newState
    case PENDING_APPROVAL_START_EDITING_CONFLICT_DECLARATIONS:
      newState.conflictDeclarations.editingDeclarations = true
      newState.conflictDeclarationsBeforeEditing = newState.pendingApprovalProfile.conflictDeclarations
      newState.independenceBeforeEditing = newState.pendingApprovalProfile.isIndependent
      newState.conflictDeclarations.isInvalid.conflictDeclarations = validiateChecklistField(newState.pendingApprovalProfile.conflictDeclarations, minimumRequiredSelection)
      newState.conflictDeclarations.isInvalid.formIsValid = formIsValid(newState.conflictDeclarations.isInvalid)
      return newState
    case PENDING_APPROVAL_STOP_EDITING_CONFLICT_DECLARATIONS:
      newState.conflictDeclarations.editingDeclarations = false
      return newState
    case PENDING_APPROVAL_CANCEL_EDITING_CONFLICT_DECLARATIONS:
      newState.conflictDeclarations.editingDeclarations = false
      newState.pendingApprovalProfile.conflictDeclarations = cloneDeep(newState.conflictDeclarationsBeforeEditing)
      newState.pendingApprovalProfile.isIndependent = cloneDeep(newState.independenceBeforeEditing)
      newState.conflictDeclarationsBeforeEditing = []
      return newState
    case PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_FETCHED_CONFLICT_DECLARATIONS:
      newState.conflictDeclarations.allDeclarations = action.payload
      return newState
    case PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_CONFLICT_DECLARATION_SELECTED_CHANGED:
      const selectedDeclarations = newState.pendingApprovalProfile.conflictDeclarations || []
      const exists = selectedDeclarations.some(
        decl => decl.conflictDeclarationId === action.conflictDeclaration.conflictDeclarationId
      )
      const updatedDeclarations = exists
        ? selectedDeclarations.filter(
          decl => decl.conflictDeclarationId !== action.conflictDeclaration.conflictDeclarationId
        )
        : [...selectedDeclarations, action.conflictDeclaration]
      newState.pendingApprovalProfile = {
        ...newState.pendingApprovalProfile,
        conflictDeclarations: updatedDeclarations,
        isIndependent: validateAllChecklistChecked(
          updatedDeclarations,
          newState.conflictDeclarations.allDeclarations,
          'conflictDeclarationId'
        )
      }
      newState.conflictDeclarations.isInvalid.conflictDeclarations = validiateChecklistField(updatedDeclarations, minimumRequiredSelection)
      newState.conflictDeclarations.isInvalid.formIsValid = formIsValid(newState.conflictDeclarations.isInvalid)
      newState.edited = true
      return newState
    case PENDING_APPROVAL_ADVISER_CONFLICT_DECLARATIONS_NO_CONFLICT_SELECTED:
      newState.pendingApprovalProfile.conflictDeclarations = []
      var isIndependentSelectedDeclarations = newState.pendingApprovalProfile.conflictDeclarations
      newState.pendingApprovalProfile.isIndependent = validateAllChecklistChecked(isIndependentSelectedDeclarations, newState.conflictDeclarations.allDeclarations, 'conflictDeclarationId')
      newState.conflictDeclarations.isInvalid.conflictDeclarations = validiateChecklistField(isIndependentSelectedDeclarations, minimumRequiredSelection)
      newState.conflictDeclarations.isInvalid.formIsValid = formIsValid(newState.conflictDeclarations.isInvalid)
      newState.edited = true
      return newState
  }
  return state
}

function copyConflictDeclarationsState (state) {
  var newState = cloneDeep(state)
  newState.pendingApprovalProfile = cloneDeep(state.pendingApprovalProfile)

  if (state.pendingApprovalProfile) {
    newState.pendingApprovalProfile.conflictDeclarations = cloneDeep(state.pendingApprovalProfile.conflictDeclarations)
  }
  return newState
}

function formIsValid (isInvalid) {
  return !isInvalid.conflictDeclarations.isInvalid
}

export function validateAllChecklistChecked (selectedList, availableList, key) {
  let allChecked = true
  availableList.forEach(availableItem => {
    let wasFound = false
    selectedList.forEach(selectedItem => {
      if (selectedItem[key] === availableItem[key]) wasFound = wasFound || true
    })
    allChecked = allChecked && wasFound
  })
  return allChecked
}

function findConflictDeclarationsDifferences (state) {
  var oldList = state.publishedProfile.conflictDeclarations
  var newList = state.pendingApprovalProfile.conflictDeclarations
  return listDifferenceComputer(oldList, newList, 'conflictDeclarationId')
}
